import React, { useEffect, useState } from "react";
import "./packagemain.css";
import "./packagemain.scss";
import { FaMapMarkerAlt, FaCalendarAlt, FaMapMarkedAlt } from "react-icons/fa";

import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import truncate from "truncate-html";

import Aos from "aos";
import "aos/dist/aos.css";
const PackageMain = ({ onOpenModal }) => {

     const [price, setPrice] = useState(500);
     const [days, setDays] = useState("any");
     const [location, setLocation] = useState("");
     const [durations, setDurations] = useState([]);
     const [destinations, setDestinations] = useState([]);
  const [people, setPeople] = useState(1);

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);


  const [data, setData] = useState([]);
 // ✅ جلب الـ durations
  useEffect(() => {
    fetch("https://admin.mythsegypttours.com/api/durations")
      .then((res) => res.json())
      .then((result) => setDurations(result || []))
      .catch((err) => console.error("Error fetching durations:", err));
  }, []);

  // ✅ جلب الـ destinations
  useEffect(() => {
    fetch("https://admin.mythsegypttours.com/api/destinations")
      .then((res) => res.json())
      .then((result) => setDestinations(result || []))
      .catch((err) => console.error("Error fetching destinations:", err));
  }, []);

  useEffect(() => {
      fetch("https://admin.mythsegypttours.com/api/packages-tours")
        .then((res) => res.json())
        .then((result) => {
          setData(result.data || []);
        })
        .catch((err) => console.error("Error fetching tours:", err));
    }, []);
  // ✨ فلترة البيانات
const filteredData = data.filter((trip) => {
  // فلتر الوجهة
  const matchLocation = location ? trip.destination_id === parseInt(location) : true;

  // فلتر المدة (days/duration)
  const matchDays = days !== "any" ? trip.duration_id === parseInt(days) : true;

  // فلتر السعر
  const matchPrice =
    trip.pricings?.length > 0
      ? Math.min(...trip.pricings.map((p) => parseFloat(p.price_per_person))) <= price
      : true;

  return matchLocation && matchDays && matchPrice;
});


let topData = filteredData;
let bottomData = [];

if (filteredData.length > 8) {
  const half = Math.ceil(filteredData.length / 2);
  topData = filteredData.slice(0, half);
  bottomData = filteredData.slice(half);
}

  return (
    <section className="packagemain tourcontainer tour-section">
        <div className="filter-tour-section">
      <motion.div
        className="formBox"
       
        animate={{ opacity: 1, y: 0 }}
      >
        <h2 className="filterTitle">🔍 Find Your Best Package</h2>

        <div className="filter-row">
            {/* Destination */}
            <div className="filter-group">
              <label>Destination</label>
              <select
                value={location}
                onChange={(e) => setLocation(e.target.value)}
              >
                <option value="">Select Location</option>
                {destinations.map((dest) => (
                  <option key={dest.id} value={dest.id}>
                    {dest.title}
                  </option>
                ))}
              </select>
            </div>

            {/* Price */}
            <div className="filter-group">
              <label>Max Budget: ${price}</label>
              <input
                type="range"
                min="10"
                max="5000"
                step="10"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
              />
            </div>

            {/* Days */}
            <div className="filter-group">
              <label>Duration</label>
              <select value={days} onChange={(e) => setDays(e.target.value)}>
                <option value="any">Any</option>
                {durations.map((d) => (
                  <option key={d.id} value={d.id}>
                    {d.name}
                  </option>
                ))}
              </select>
            </div>
          </div>

        {/* Button */}
       
      </motion.div>
    </div>
      <div className="secTitle">
        <span>Top Rated Packages</span>
        <h2 className="title">
        Best Holidays and vacations to Egypt
        </h2>
        <p>Discover our best Egypt travel categories for Egypt trips to create your best Egypt tour plan. Experience</p>
      </div>

      <div className="secContent-card grid">
   {filteredData.length > 0 ? (
    topData.map((trip)=> {
  const firstImage = trip.images?.length
    ? `https://admin.mythsegypttours.com/storage/${trip.images[0]}`
    : "https://via.placeholder.com/400x250";

      return (
                              <div key={trip.id} className="singleDestination_popular">
                                <div className="imgDiv">
                                  <img src={firstImage} alt={trip.title} />
                                </div>
                                <h5 className="desTitle">{trip.title}</h5>
                
                                <div className="cardInfo">
                                  <div className="flex-container_p">
                                    <span className="continent flex">
                                      <FaMapMarkedAlt className="icon_p" /> {trip.places}
                                    </span>
                                    <span className="continent flex">
                                      <FaCalendarAlt className="icon_p" /> {trip.days}
                                    </span>
                                    <span className="continent flex">
                                      <FaMapMarkerAlt className="icon_p" /> {trip.destination?.title || "No Destination"}
                                    </span>
    
                                  </div>
                
                                  <div className="fees flex">
                                    <div className="price">
                                      <h5>
                                        ${trip.pricings?.length > 0 
                    ? Math.min(...trip.pricings.map(p => parseFloat(p.price_per_person))) 
                    : "N/A"}
                                        <span>/Person</span>
                                      </h5>
                                    </div>
                
                          <Link to={`/tour-details/${trip.id}`}>
                  <button className="bookBtn">PACKAGE DETAILS</button>
                </Link>
                
                                  </div>
                                </div>
                              </div>
                            );
    })
  ) : (
    <p>Loading...</p>
  )}
</div>
 <div className="offer-one-tour-main">
  <div className="offer-content">
    <h1>Make your Ideal Egypt Itinerary Now!</h1>
    <span className="offer-content-h3">Tailor Made Your Egypt Trips</span>
    <div className="tailor-made_spo d-grid_spo">
        <a
              href="#"
              className="theme-btn btn-style-three-spo"
              onClick={(e) => {
                e.preventDefault();
                onOpenModal(); // 👈 فتح المودال
              }}
            >
              Design Your Perfect Egypt Tour Now
            </a>
    </div>
  </div>
</div>
<div className="secContent grid">
    {filteredData.length > 0 ? (
    bottomData.map((trip)=> {
  const firstImage = trip.images?.length
    ? `https://admin.mythsegypttours.com/storage/${trip.images[0]}`
    : "https://via.placeholder.com/400x250";

      return (
                              <div key={trip.id} className="singleDestination_popular">
                                <div className="imgDiv">
                                  <img src={firstImage} alt={trip.title} />
                                </div>
                                <h5 className="desTitle">{trip.title}</h5>
                
                                <div className="cardInfo">
                                  <div className="flex-container_p">
                                    <span className="continent flex">
                                      <FaMapMarkedAlt className="icon_p" /> {trip.places}
                                    </span>
                                    <span className="continent flex">
                                      <FaCalendarAlt className="icon_p" /> {trip.days}
                                    </span>
                                    <span className="continent flex">
                                      <FaMapMarkerAlt className="icon_p" /> {trip.destination?.title || "No Destination"}
                                    </span>
    
                                  </div>
                
                                  <div className="fees flex">
                                    <div className="price">
                                      <h5>
                                        ${trip.pricings?.length > 0 
                    ? Math.min(...trip.pricings.map(p => parseFloat(p.price_per_person))) 
                    : "N/A"}
                                        <span>/Person</span>
                                      </h5>
                                    </div>
                
                          <Link to={`/tour-details/${trip.id}`}>
                  <button className="bookBtn">TOUR DETAILS</button>
                </Link>
                
                                  </div>
                                </div>
                              </div>
                            );
    })
  ) : (
    <p>Loading...</p>
  )}
</div>

    </section>

    
  );
};

export default PackageMain;
